export const CREATE_HORSE = /* GraphQL */ `
  mutation HorseMutation($input: CreateHorseInput!) {
    createHorse(input: $input) {
      color
      createdAt
      dob
      height
      id
      name
      photo
      scannedAt
      status
      updatedAt
      weight
      discipline
      isDeleted
    }
  }
`;

export const VERIFY_HORSE_PREV_OWNERSHIP = /* GraphQL */ `
  mutation VerifyHorsePrevOwnership($input: VerifyHorsePrevOwnershipInput!) {
    verifyHorsePrevOwnership(input: $input) {
      color
      createdAt
      dob
      height
      id
      name
      photo
      scannedAt
      status
      updatedAt
      weight
      discipline
      isDeleted
      registeredName
    }
  }
`;


export const UPDATE_HORSE = /* GraphQL */ `
  mutation HorseMutation($input: UpdateHorseInput!) {
    updateHorse(input: $input) {
      color
      createdAt
      dob
      height
      id
      name
      photo
      scannedAt
      status
      updatedAt
      weight
      discipline
      isDeleted
      registeredName
    }
  }
`;


export const DELETE_HORSES = /* GraphQL */ `
  mutation HorseMutation($ids: [ID!]!) {
    deleteHorse(ids: $ids) {
      id
    }
  }
`;